import React from "react";
import SEO from "../components/SEO";
import Header from "../components/Header";
import Footer from "../components/Footer";

import bannerImg from "../assets/images/policy/Privacy.jpg";

import "../assets/css/Policy.css";

const PrivacyPolicy = () => {
  return (
    <>
      <SEO page="privacy" />
      <Header />

      {/* Banner */}
      <section
        className="policy-banner"
        style={{
          backgroundImage: `url(${bannerImg})`,
        }}
      >
        <div className="policy-overlay"></div>

        <div className="container">
          <div className="policy-content">
            <h1 className="policy-title">
              Privacy Policy
            </h1>
          </div>
        </div>
      </section>

      {/* Policy Content */}
      <section className="policy-section">
        <div className="container">

          <div className="policy-wrapper">

            <p>
              Innothrust (“we,” “us,” or “our”) is committed
              to protecting the privacy of our users.
              This Privacy Policy explains how we collect,
              use, disclose, and safeguard your information
              when you use our IT services through our website.
            </p>

            <h3>1. Information We Collect</h3>

            <p>
              1.1. <strong>Personal Information:</strong>
              We may collect personal information that
              you voluntarily provide to us when you use
              our services, such as your name,
              designation, company, email address,
              or phone number.
            </p>

            <p>
              If you are using any of our pages for
              submitting your resume for job related purpose,
              then you are voluntarily doing so, and as
              a result we may have your resume or related details.
            </p>

            <p>
              1.2. <strong>Usage Data:</strong>
              We may also collect information about how
              you access and use our Website,
              including your IP address, browser type,
              pages visited, and time spent on our site.
            </p>

            <h3>2. How We Use Your Information</h3>

            <p>
              2.1. We may use the information we collect
              for various purposes, including to:
            </p>

            <ul>
              <li>Provide and maintain our services.</li>

              <li>
                Process transactions and fulfill requests.
              </li>

              <li>
                Communicate with you about our services
                and updates.
              </li>

              <li>
                Personalize your experience and improve
                our Website.
              </li>

              <li>
                Detect, prevent, and address technical issues.
              </li>
            </ul>

            <h3>3. Disclosure of Your Information</h3>

            <p>
              3.1. We may disclose your information to
              third parties, including:
            </p>

            <ul>
              <li>
                Service providers who assist us in operating
                our Website or providing our services.
              </li>

              <li>
                Law enforcement or government agencies
                in response to a valid legal request.
              </li>
            </ul>

            <h3>4. Data Security</h3>

            <p>
              4.1. We implement reasonable security measures
              to protect your information from unauthorized
              access, alteration, disclosure, or destruction.
            </p>

            <p>
              However, no method of transmission over the
              internet or electronic storage is 100% secure,
              and we cannot guarantee absolute security.
            </p>

            <h3>5. Your Choices</h3>

            <p>
              5.1. You may choose not to provide certain
              information, but this may limit your ability
              to use some features of our Website.
            </p>

            <p>
              5.2. You can opt out of receiving promotional
              communications from us by following the
              instructions in those communications or by
              contacting us directly.
            </p>

            <h3>6. Third-Party Links</h3>

            <p>
              6.1. Our Website may contain links to
              third-party websites or services that are
              not owned or controlled by us.
            </p>

            <p>
              We are not responsible for the privacy
              practices or content of these third-party sites.
            </p>

            <h3>7. Children's Privacy</h3>

            <p>
              7.1. Our services are not directed to
              children under the age of 18, and we do
              not knowingly collect personal information
              from children.
            </p>

            <p>
              If you are a parent or guardian and believe
              that your child has provided us with personal
              information, please contact us so that we can
              delete their information.
            </p>

            <h3>8. Changes to This Policy</h3>

            <p>
              8.1. We may update this Privacy Policy from
              time to time, and any changes will be posted
              on this page.
            </p>

            <p>
              We encourage you to review this Privacy Policy
              periodically for any updates.
            </p>

            <h3>9. Contact Us</h3>

            <p>
              9.1. If you have any questions or concerns
              about this Privacy Policy, please write to us
              at info@Innothrust.com or refer to our contact
              page for more details.
            </p>

            <h3>10. No Unsolicited Calls Policy</h3>

            <p>
              10.1. We value our user’s privacy and are
              committed to maintaining a respectful and
              considerate communication approach.
            </p>

            <p>
              We will not initiate phone contact with
              individuals unless they have registered as
              customers, submitted an application for
              employment opportunities, or raised a direct
              or indirect inquiry through our platform
              or channels.
            </p>

          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;